/**
 * Which of a Thread's actions the header offers, all on one row beside where it runs (F67:
 * nothing crucial hidden under More). Running a step and answering a person step belong to
 * the current step (F33); where it runs and on which agent, to the hosting line (F55). Going
 * offline is not the Thread's to own, every message is a request to the agent (F70), and a Thread
 * is put away by settling it in the list (F69). Removing it with everything it wrote comes last,
 * for whoever may delete the project (Johannes, 3 Nov). Pure, so the order and the leading action
 * are tested in one place.
 */

/** The header's actions, in the order shown. */
export type ThreadAction = "reopen" | "fork" | "saveAsWorkflow" | "runOnManyDocuments" | "handOff" | "leaveWorkflow" | "resumeWorkflow" | "remove";

const ORDER: readonly ThreadAction[] = ["reopen", "fork", "saveAsWorkflow", "runOnManyDocuments", "handOff", "leaveWorkflow", "resumeWorkflow", "remove"];

/**
 * Whether this viewer has each action now: module C decides the host's (W-22 slice 4), the project's permissions
 * fork, Save as Workflow and Remove. The header lists only what the viewer may do; a non-host's way to the host's
 * actions is the hosting line's Take over.
 */
export type ThreadActionFacts = Readonly<Record<ThreadAction, boolean>> & {
  /** Module C lets the viewer write in the Run now: one who can't is led to Fork. */
  readonly mayWrite: boolean;
};

export interface ThreadActionLayout {
  readonly actions: readonly ThreadAction[];
  /** The one action shown as primary: Reopen for a closed Thread's host; Fork for a viewer who can't write. */
  readonly leading: ThreadAction | null;
}

export function threadActionLayout(facts: ThreadActionFacts): ThreadActionLayout {
  const actions = ORDER.filter((action) => facts[action]);
  const leading = actions.includes("reopen") ? "reopen" : actions.includes("fork") && !facts.mayWrite ? "fork" : null;
  return { actions, leading };
}
